import styles from './heroCardList.module.scss';
import CardLC from '../cardLC/cardLC';
import PagayaCard from '../pagayaCard/pagayaCard';

export default function HeroCardList({ rightCard, leftCard }) {
  return (
    <div className={styles.heroCardWrapper}>
      <div className={styles.leftCard}>
        <CardLC {...leftCard} />
      </div>
      <div className={styles.rightCard}>
        <PagayaCard {...rightCard} heapSelector="tally_pagaya_cta" />
      </div>
    </div>
  );
}
